export default __webpack_public_path__ + "SEQzyme-video-image.png";